import { SVGProps } from 'react'

export const PhotoCamera = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none" viewBox="0 0 36 36" {...props}>
    <rect width="36" height="36" fill="#3A79E0" rx="18"></rect>
    <path fill="#fff" d="M18 21.333a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"></path>
    <path
      fill="#fff"
      d="M24.667 12.167h-2.642l-1.033-1.125a1.659 1.659 0 00-1.225-.542h-3.533c-.467 0-.917.2-1.234.542l-1.025 1.125h-2.641c-.917 0-1.667.75-1.667 1.666v10c0 .917.75 1.667 1.667 1.667h13.333c.917 0 1.667-.75 1.667-1.667v-10c0-.916-.75-1.666-1.667-1.666zM18 23a4.168 4.168 0 01-4.166-4.167c0-2.3 1.866-4.166 4.166-4.166 2.3 0 4.167 1.866 4.167 4.166C22.167 21.133 20.3 23 18 23z"
    ></path>
  </svg>
)
